export default __webpack_public_path__ + "static/media/ic_gmx_arbitrum.d7115a71.svg";